import React from 'react'
import { Popper, Fade, ClickAwayListener, ToggleButtonGroup, ToggleButton, IconButton, Box } from '@mui/material'
import { Language, Check } from '@mui/icons-material'
import { onChangeLanguage } from '../actions'
import { useSelector, useDispatch } from 'react-redux'
import { IReducer } from '../interface'
import { useCookies } from 'react-cookie'
import { PaperDropdown } from 'src/styles'

export default function Region() {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const changeLanguage = useSelector((state: IReducer) => state.changeLanguage)
  const [region, setRegion] = React.useState(changeLanguage.lang)
  const dispatch = useDispatch()
  const [, setCookies] = useCookies(['language'])

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const handleChange = (event: React.MouseEvent<HTMLElement>, newLanguage: string) => {
    event.preventDefault()
    if (newLanguage) {
      setRegion(newLanguage)
      setCookies('language', newLanguage, { path: '/' })
      dispatch(onChangeLanguage(newLanguage))
    }
  }

  return (
    <Box id='language-selector'>
      <IconButton
        color='secondary'
        disableTouchRipple
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup='true'
        onClick={handleToggle}
      >
        <Language />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement='bottom-end'
        sx={{ zIndex: 9 }}
      >
        {({ TransitionProps, placement }) => (
          <Fade {...TransitionProps} style={{ transformOrigin: placement }}>
            <PaperDropdown data-gtm-click-subsection1='Language Icon'>
              <ClickAwayListener onClickAway={handleClose}>
                <ToggleButtonGroup
                  orientation='vertical'
                  value={region}
                  exclusive
                  onClick={handleClose}
                  onChange={handleChange}
                  aria-label='Platform'
                  sx={{ py: 0 }}
                  fullWidth
                >
                  {changeLanguage.availableLanguages.map((value, index) => (
                    <ToggleButton
                      id='language-button'
                      value={value.key}
                      disableRipple
                      key={index}
                      className='nav-dropdown'
                      sx={{ textTransform: 'capitalize' }}
                    >
                      <Check
                        color='primary'
                        sx={{ mr: 1.5, ml: -0.5, width: 16, opacity: region === value.key ? 1 : 0 }}
                      />
                      {value.text}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </ClickAwayListener>
            </PaperDropdown>
          </Fade>
        )}
      </Popper>
    </Box>
  )
}
